import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { isAuthorizedAccess } from "./utils/helpers";
import UnauthorizedAccess from "./pages/unauthorized-access/component";
import { useNavigate } from "react-router-dom";
import { ComponentList } from "./routing/componentlist";
import SignOut from "./pages/sign-out/component";
import SignIn from "./pages/sign-in/component";
import SignUp from "./pages/sign-up/component";
import PageNotFound from "./pages/page-not-found/component";
import withAppInsights from "./AppInsights";
import SessionExpire from "./pages/session-expire/component";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getGoogleClientId } from "./utils/general-config";
import Home from "./pages/home/component";
import ForgotPassword from "./pages/forgot-password/component";
import ResetPassword from "./pages/reset-password/component";
const RenderRoutes = (props) => {
  const localtion = useLocation();
  const { pathname } = localtion;
  const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;
  console.log("current-environment::", currentEnv);
  const navigate = useNavigate();
  const [showHome, setShowHome] = useState(false);

  useEffect(() => {
    setShowHome(true);
    if (localtion.pathname.indexOf("/en/") > -1) {
      const path = localtion.pathname.replaceAll("/en/", "/");
      return navigate(path);
    }
    // if (
    //   !!currentStep &&
    //   (pathname == "/" || pathname == "/app" || pathname == "/app/")
    // ) {
    //   navigate(currentStep);
    //   setShowHome(false);
    // } else {
    //   setShowHome(true);
    // }
  }, []);

  return (
    <>
      <Routes>
        {!isAuthorizedAccess() && <Route element={UnauthorizedAccess} />}
        {/* {console.log("access", isAuthorizedAccess())} */}

        {/* <Route
          element={
            <GoogleOAuthProvider clientId={getGoogleClientId()}>
              <SignUp />
            </GoogleOAuthProvider>
          }
        >
          <Route
            path={ComponentList.Home.Path}
            element={
              showHome ? (
                <GoogleOAuthProvider clientId={getGoogleClientId()}>
                  <BillingTransfer />
                </GoogleOAuthProvider>
              ) : (
                <></>
              )
            }
          />
          <Route
            path={ComponentList.Home.LocalePath}
            element={
              showHome ? (
                <GoogleOAuthProvider clientId={getGoogleClientId()}>
                  <BillingTransfer />
                </GoogleOAuthProvider>
              ) : (
                <></>
              )
            }
          />
        </Route> */}
        <Route
          element={
            <GoogleOAuthProvider clientId={getGoogleClientId()}>
              <SignIn />
            </GoogleOAuthProvider>
          }
        >
          <Route
            path={ComponentList.SignIn.Path}
            element={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <SignIn />
              </GoogleOAuthProvider>
            }
          />
          <Route
            path={ComponentList.SignIn.LocalePath}
            element={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <SignIn />
              </GoogleOAuthProvider>
            }
          />
        </Route>
        <Route
          element={
            <GoogleOAuthProvider clientId={getGoogleClientId()}>
              <SignUp />
            </GoogleOAuthProvider>
          }
        >
          <Route
            path={ComponentList.SignUp.Path}
            element={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <SignUp />
              </GoogleOAuthProvider>
            }
          />
          <Route
            path={ComponentList.SignUp.LocalePath}
            element={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <SignUp />
              </GoogleOAuthProvider>
            }
          />
        </Route>

        <Route element={<ForgotPassword />}>
          <Route path={ComponentList.ForgotPassword.Path} element={<ForgotPassword />} />
          <Route path={ComponentList.ForgotPassword.LocalePath} element={<ForgotPassword />} />
        </Route>

        <Route element={<SignOut />}>
          <Route path={ComponentList.SignOut.Path} element={<SignOut />} />
          <Route path={ComponentList.SignOut.LocalePath} element={<SignOut />} />
        </Route>

        <Route element={<ResetPassword />}>
          <Route path={ComponentList.ResetPassword.Path} element={<ResetPassword />} />
          <Route path={ComponentList.ResetPassword.LocalePath} element={<ResetPassword />} />
        </Route>

        <Route element={<SessionExpire />}>
          <Route path={ComponentList.SessionExpire.Path} element={<SessionExpire />} />
          <Route path={ComponentList.SessionExpire.LocalePath} element={<SessionExpire />} />
        </Route>

        <Route exact path={ComponentList.AdminLogin.Path} element={ComponentList.AdminLogin.Component} />
        {/* <Route path={"*"} element={<PageNotFound />} /> */}

        <Route element={<PageNotFound />}>
          <Route path={"*"} element={<PageNotFound />} />
          <Route path={ComponentList.PageNotFound.LocalePath} element={<PageNotFound />} />
        </Route>
        <Route element={<Home />}>
          <Route path={ComponentList.Home.Path} element={<Home />} />
          <Route path={ComponentList.Home.LocalePath} element={<Home />} />
        </Route>
      </Routes>
    </>
  );
};
export default withAppInsights(RenderRoutes);
